import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

import Sidebar from './components/Sidebar';
import TopNav from './components/TopNav';

import PublicLanding from './pages/PublicLanding';
import Overview from './pages/Overview';
import Youtube from './pages/Youtube';
import Blog from './pages/Blog';
import Linkedin from './pages/Linkedin';
import FeedAd from './pages/FeedAd';
import Schedule from './pages/Schedule';
import CampaignPerformance from './pages/CampaignPerformance';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      setSidebarOpen(!mobile);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      {isAuthenticated ? (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
          <TopNav toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />
          <div style={{ display: 'flex', flex: 1, minHeight: 0 }}>
            <Sidebar
              isOpen={isSidebarOpen || !isMobile}
              isMobile={isMobile}
              closeSidebar={() => setSidebarOpen(false)}
            />
            <div
              style={{
                flex: 1,
                overflowY: 'auto',
                height: '100%',
                paddingBottom: '2rem',
                backgroundColor: '#fafafa'
              }}
            >
              <Routes>
                <Route path="/" element={<Navigate to="/overview" />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/youtube" element={<Youtube />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/linkedin" element={<Linkedin />} />
                <Route path="/feed" element={<FeedAd />} />
                <Route path="/schedule" element={<Schedule />} />
                <Route path="/performance" element={<CampaignPerformance />} />
              </Routes>
            </div>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="*" element={<PublicLanding />} />
        </Routes>
      )}
    </Router>
  );
}

export default App;